export default __webpack_public_path__ + "static/media/bianji.5262f791.png";